import React from "react";
// import Link from "next/link";
import { colors, font } from "utils/styles";
import DynamicLink from "@components/Reusables/DynamicLink";
export default function NavSide(props) {
	return (
		<section className=" side">
			{props.data.title && <Title text={props.data.title} />}
			{props.data.data.map((d, i) => {
				return <SideElement key={i} data={d} />;
			})}
			{/* <Details text={props.data.details} /> */}
			{/* <LearnMoreBtn text={props.data.buttonText} link={props.data.link} /> */}
			<style jsx="true">{`
				.side {
					height: 100%;
					background: ${colors.darkBlue};
					color: ${colors.white};
					width: auto;
					padding-top: 3rem;
					padding-left: 2em;
					padding-right: 0.5em;
					max-width: 255px;
					min-width: 255px;
				}
			`}</style>
		</section>
	);
}

function SideElement({ data }) {
	return (
		<span className="pb-3 d-block ">
			{data.buttonText && (
				<>
					{data.title && <Title text={data.title} />}
					{data.subTitle && <SubTitle text={data.subTitle} />}
					{data.dateLocation && <DateLocation text={data.dateLocation} />}
					{data.details && <Details text={data.details} />}
					{data.buttonText && <LearnMoreBtn text={data.buttonText} link={data.link} />}
				</>
			)}
			{!data.buttonText && (
				<>
					<DynamicLink classes=" " href={data.link}>
						<SubTitle text={data.subTitle} />
						<DateLocation text={data.dateLocation} />
					</DynamicLink>
				</>
			)}
		</span>
	);
}
function Title(props) {
	return (
		<h2
			style={{
				// marginBottom: "1em",
				fontFamily: "Open Sans",
				fontSize: "13px",
				lineHeight: "28px",
				fontWeight: "400",
				color: colors.white,
			}}
		>
			{props.text}
		</h2>
	);
}
function DateLocation(props) {
	return (
		<p
			style={{
				fontSize: "16px",
				lineHeight: "20px",
				// fontWeight: "bold",
				color: colors.white,
			}}
		>
			{props.text}
		</p>
	);
}

function SubTitle(props) {
	return (
		<h3
			style={{
				marginBottom: ".5em",
				fontWeight: "600",
				fontSize: "22px",
				lineHeight: "24px",
				fontFamily: font.Athelas,
			}}
		>
			{props.text}
		</h3>
	);
}

function LearnMoreBtn(props) {
	return (
		<DynamicLink href={props.link || "#"}>
			{/* <a> */}
			<p
				style={{
					border: `1px solid ${colors.white}`,
					fontSize: "15px",
					display: "inline-flex",
					padding: "0.5em 1em",
					color: colors.white,
					borderRadius: "3px",
				}}
			>
				{props.text}
			</p>
			{/* </a> */}
		</DynamicLink>
	);
}
function Details(props) {
	return (
		<p
			className="mb-4  pe-0"
			style={{
				fontSize: "16px",
				lineHeight: "22px",
				fontWeight: "regular",
				fontFamily: "Open Sans",
				minWidth: "190px",
				maxWidth: "190px",
				// width: "auto",

				color: colors.white,
				// paddingRight: "3em",
			}}
		>
			{props.text}
		</p>
	);
}
